import type { CommitmentTierUsageData } from '@weft/types';

export const calculateCommitmentUnitsAmount = (commitmentTiersUsageMap: Record<string, CommitmentTierUsageData[]>, productVariantId: string) => {
  return commitmentTiersUsageMap[productVariantId]?.reduce((totalCommitment, tierUsage) => {
    return totalCommitment + (tierUsage.periodUnits - tierUsage.billableUnits);
  }, 0);
};
  
export const isThereCommitmentUnits = (commitmentTiersUsageMap: Record<string, CommitmentTierUsageData[]>, productVariantId: string) => {
  const commitment = calculateCommitmentUnitsAmount(commitmentTiersUsageMap, productVariantId);
  
  return commitment > 0;
};